export default {
  "Container": "_Container_t28p4_1",
  "Line": "_Line_t28p4_9",
  "Dot": "_Dot_t28p4_23",
  "Label": "_Label_t28p4_34"
};import "ni:sha-256;1fKj2opfIof_CheJyyJNRaMPlJiTiMcaDWudUurIvPk";